export const TIMEOUT = 8000;
export const PRINTTIME = 10000;
export const IDLETIMER_TIMEOUT = 1000 * 60 * 3; // default to 3 minutes
export const IDLETIMER_PROMT = 1000 * 30; // default to 30 seconds
